import React, { useEffect, useState } from "react";
import Messageservice from "../../../services/KangarooServices/MessageService";
import { Button, Card, Col, Container, Row } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { imageBaseApi } from "../../../utilis/imageHelper";

const MessageDetails = () => {
  const { slug } = useParams();
  const [details, setDetails] = useState("");
  const navigate = useNavigate();
  const fetchDetail = async () => {
    try {
      const response = await Messageservice.getbySlug(slug);
      setDetails(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (slug) {
      fetchDetail();
    }
  }, [slug]);

  console.log("🚀 ~ MessageDetails ~ details:", details);
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Message Details"
          pageTitle="Message From CEO"
          breadcrumbItems={[
            { title: "Back to List", link: "/message-from-ceo" },
          ]}
        />
        <Card className="p-4 p-md-5 shadow-sm border-0">
          <Row>
            <Col md={8}>
              <h1
                className="lh-1"
                style={{
                  fontSize: "clamp(30px, 5vw, 62px)",
                  color: "#7e1790",
                  fontFamily: "Proxima Nova Black",
                  marginBottom: "4.5rem",
                }}
              >
                {details?.heading}
              </h1>
            </Col>
            <Col>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                  color="warning"
                  size="md"
                  outline
                  onClick={() =>
                    navigate(`/message-from-ceo/update/${details.id}`)
                  }
                >
                  <i className="ri-edit-line me-1"></i>Edit
                </Button>
                {/* <Button
                  color="primary"
                  size="sm"
                  outline
                  onClick={() =>
                    navigate(`/message-from-ceo/details/${item.slug}`)
                  }
                >
                  <i className="ri-edit-line">Details</i>
                </Button> */}
              </div>
            </Col>
          </Row>
          <Row className="align-items-center ">
            <Col lg={6} sm={12}>
              <img
                src={`${imageBaseApi}${details?.ceoImage?.url}`}
                className="w-100 h-100 mb-4 mb-md-0"
                alt=""
                fluid
              />
            </Col>
            <Col lg={6} sm={12}>
              <p
                style={{
                  fontFamily: "Proxima Nova Regular",
                  fontSize: "26px",
                  lineHeight: "31.2px",
                  color: "#687c86",
                }}
              >
                {details?.subHeading}
              </p>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: "clamp(2.5rem,6vw,6.7rem)" }}>
              <p
                className="about-desc-font "
                dangerouslySetInnerHTML={{ __html: details?.message }}
              ></p>
            </Col>
          </Row>
        </Card>
      </Container>
    </div>
  );
};

export default MessageDetails;
